import { Label as LabelPrimitive } from "radix-ui"

import { cn } from "@/lib/utils"

/**
 * The stock shadcn label, at this product's field-label size.
 *
 * WHY A LABEL PRIMITIVE AND NOT `aria-label`. Every field in this app used to
 * carry its name as a placeholder plus an `aria-label`, which fails three
 * different people: the placeholder vanishes the moment anybody types, so a
 * half-filled form no longer says what its fields are; the text sits at
 * placeholder contrast, which is deliberately below the contrast a label needs;
 * and an `aria-label` is invisible, so the label is not a TAP TARGET — a real
 * `<label for>` focuses the control it names, which on a phone doubles the size
 * of everything the thumb is aiming at.
 *
 * Radix's label is the stock component and it earns its place over a bare
 * `<label>` by suppressing the text selection a double-tap on a label otherwise
 * produces, which is the mobile-only defect a hand-rolled one always ships with.
 *
 * 13px MUTED, matching the one hand-written label this app already had (the date
 * of birth on the onboarding form) and the `Note` measure beside it. A label is
 * scaffolding for the value; it must not compete with what somebody typed.
 */
function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-[13px] leading-none font-medium text-muted-foreground select-none",
        "group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Label }
